import brandLogo from '../assets/images/Ravindraa-home--decor-logo.jpeg';
import vastu1 from '../assets/Vastu-consultation/Home Vastu with Kundali.jpeg';
import vastu2 from '../assets/Vastu-consultation/Vastu Bed Direction.jpeg';
import vastu3 from '../assets/Vastu-consultation/Vastu Direction Colors.jpeg';
import vastu4 from '../assets/Vastu-consultation/Vastu Directions Living Space.jpeg';
import vastu5 from '../assets/Vastu-consultation/Vastu Home Direction.jpeg';
import vastu6 from '../assets/Vastu-consultation/Vedic astrology.jpeg';
import { loadImagesFromFolder } from '../utils/imageLoader';

const interiorAssets = require.context('../assets/Interior', false, /\.(jpe?g|png|webp|avif)$/i);
const upvcAssets = require.context('../assets/UPVC-windows', false, /\.(jpe?g|png|webp|avif)$/i);
const loungeAssets = require.context(
  '../assets/Lounge Wall Paneling',
  false,
  /\.(jpe?g|png|webp|avif)$/i
);

const formatImageTitle = (fileName) =>
  fileName
    .replace(/\.(jpe?g|png|webp|avif)$/i, '')
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (character) => character.toUpperCase());

const buildGalleryFromContext = (assets) =>
  assets
    .keys()
    .sort((left, right) => left.localeCompare(right))
    .map((key) => {
      const fileName = key.replace(/^\.\//, '');

      return {
        url: assets(key),
        title: formatImageTitle(fileName),
      };
    });

const interiorGallery = buildGalleryFromContext(interiorAssets);
const upvcGallery = buildGalleryFromContext(upvcAssets);
const loungeGallery = buildGalleryFromContext(loungeAssets);
const constructionAssetsGallery = loadImagesFromFolder('Construction');

const combinedWallPanelGallery = loungeGallery;
const upvcCrystalCasement = upvcGallery.find((image) => image.title === 'The Crystal Casement');
const upvcGalleryOrdered = (
  upvcCrystalCasement
    ? [
      upvcCrystalCasement,
      ...upvcGallery.filter((image) => image.title !== 'The Crystal Casement'),
    ]
    : upvcGallery
).filter((image) => image.title?.toLowerCase() !== 'sliding white PROMINANCE UPVC Windows');

const laminatedDoorImage = interiorGallery.find(
  (image) => image.title?.toLowerCase() === 'laminated upvc door'
);
const interiorGalleryOrdered = interiorGallery.filter(
  (image) => image.title?.toLowerCase() !== 'laminated upvc door'
);

if (
  laminatedDoorImage &&
  !upvcGalleryOrdered.some((image) => image.url === laminatedDoorImage.url)
) {
  const insertIndex = Math.min(2, upvcGalleryOrdered.length);
  upvcGalleryOrdered.splice(insertIndex, 0, laminatedDoorImage);
}

export const COMPANY = {
  name: 'RAVINDRAA',
  subtitle: 'Home & Decor',
  logo: brandLogo,
  phone: '+916376237823',
  whatsapp: '916376237823',
  email: 'ravindraahomes@gmail.com',
  address: 'Bikaner, Rajasthan, India',
  mapLink: 'https://maps.app.goo.gl/1WZ7oCPYeVDAeEwr9?g_st=aw',
  instagramLink: 'https://www.instagram.com/p/DWyoAWMj5bv/?igsh=ZmU1bWl2MGNiNnR0',
  facebookLink: 'https://www.facebook.com/share/1CZo6s4a8V/',
};

export const SLIDES = [
  {
    title: 'Your Bikaner Home Crafted With Local Expertise & Trust',
    image:
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&q=80&w=2000',
  },
  {
    title: 'Modern PVC Interiors Built for Rajasthan Climate',
    image:
      'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&q=80&w=2000',
  },
  {
    title: 'Construction Done Right—Quality That Lasts',
    image:
      'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=2000&q=80',
  },
  {
    title: 'Vastu Principles for Homes That Feel Right',
    image:
      'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&q=80&w=2000',
  },
  {
    title: 'Smart Real Estate Decisions in Bikaner & Rajasthan',
    image:
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&q=80&w=2000',
  },
];

export const SERVICES = [
  {
    title: 'Real Estate Consulting',
    icon: 'building',
    desc: 'Trusted property consulting backed by deep local market expertise.',
    image:
      'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=800&q=80',
    gallery: [
      {
        url: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1200&q=80',
        title: 'Luxury Villa Properties',
      },
      {
        url: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?auto=format&fit=crop&w=1200&q=80',
        title: 'Modern Residential Complexes',
      },
      {
        url: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=80',
        title: 'Premium Property Portfolio',
      },
      {
        url: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1200&q=80',
        title: 'Investment Properties',
      },
      {
        url: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80',
        title: 'Commercial Real Estate',
      },
      {
        url: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1200&q=80',
        title: 'Residential Plots',
      },
    ],
  },
  {
    title: 'PVC Home Decor',
    icon: 'sparkles',
    desc: 'Premium PVC decor crafted for modern Rajasthan homes.',
    image: interiorGalleryOrdered[0]?.url,
    gallery: interiorGalleryOrdered,
  },
  {
    title: 'PROMINANCE UPVC Windows',
    icon: 'window',
    desc: 'Heat-smart PROMINANCE UPVC Windows designed for comfort, light, and security.',
    image: upvcCrystalCasement?.url || upvcGallery[0]?.url,
    gallery: upvcGalleryOrdered,
  },
  {
    title: 'Building Construction',
    icon: 'home',
    desc: 'Complete construction solutions from planning to final handover.',
    image:
      'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=800&q=80',
    constructionCategories: [
      {
        name: 'Construction',
        description: 'Automatically synced construction images from our local asset folder.',
        gallery: constructionAssetsGallery,
      },
    ],
  },
  {
    title: 'Architecture Services',
    icon: 'briefcase',
    desc: 'Practical architectural planning with modern, build-ready designs.',
    image:
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=800&q=80',
    gallery: [
      {
        url: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80',
        title: 'Modern Architecture Design',
      },
      {
        url: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=80',
        title: '3D Building Renders',
      },
      {
        url: 'https://images.unsplash.com/photo-1600210492493-0946911123ea?auto=format&fit=crop&w=1200&q=80',
        title: 'Floor Plan Designs',
      },
      {
        url: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80',
        title: 'Contemporary Architecture',
      },
      {
        url: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1200&q=80',
        title: 'Luxury Home Design',
      },
      {
        url: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1200&q=80',
        title: 'Interior Architecture',
      },
    ],
  },
  {
    title: 'Vastu Consultation',
    icon: 'ruler',
    desc: 'Balanced vastu guidance blended with practical modern living.',
    image: vastu1,
    gallery: [
      {
        url: vastu1,
        title: formatImageTitle('Home Vastu with Kundali.jpeg'),
      },
      {
        url: vastu2,
        title: formatImageTitle('Vastu Bed Direction.jpeg'),
      },
      {
        url: vastu3,
        title: formatImageTitle('Vastu Direction Colors.jpeg'),
      },
      {
        url: vastu4,
        title: formatImageTitle('Vastu Directions Living Space.jpeg'),
      },
      {
        url: vastu5,
        title: formatImageTitle('Vastu Home Direction.jpeg'),
      },
      {
        url: vastu6,
        title: formatImageTitle('Vedic astrology.jpeg'),
      },
    ],
  },
];

export const PROJECTS = [
  {
    img: 'https://images.unsplash.com/photo-1600607686527-6fb886090705?auto=format&fit=crop&w=800&q=80',
    category: 'Modern Homes',
    title: 'The Imperial Villa',
    description:
      'A luxury residential project featuring modern architecture with traditional Rajasthani elements. Complete construction with premium finishes, custom PROMINANCE UPVC Windows, and vastu-aligned room planning.',
  },
  {
    img:
      loungeGallery[0]?.url ||
      'https://images.unsplash.com/photo-1600210492493-0946911123ea?auto=format&fit=crop&w=800&q=80',
    category: 'PVC Decor',
    title: 'Lounge Wall Paneling',
    description:
      'Luxury PVC wall panel installation transforming a living room with 3D textured finishes. Durable, heat-resistant, and designed to complement Bikaner home aesthetics while maintaining easy maintenance.',
    gallery: combinedWallPanelGallery,
  },
  {
    img: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=800&q=80',
    category: 'Construction',
    title: 'Complete Home Construction',
    description:
      'End-to-end residential construction from foundation to interior finishing. Built with climate-appropriate materials, modern structural engineering, and quality standards suited for long-term Bikaner living.',
  },
];

export const WHY_US = [
  'Local Expertise Built on 15+ Years in Bikaner',
  'Quality Materials That Survive Rajasthan Weather',
  'Timely Delivery Without Cutting Corners',
  'Clear Pricing—No Hidden Charges',
  'Designs That Balance Modern Style With Practicality',
  'Support After Handover—We Stand Behind Our Work',
];

export const NAV_ITEMS = ['Home', 'About', 'Services', 'Projects', 'Team', 'Contact'];
